//+++++++++++++++++++++++++++++++++++++++++++++++
// ScrollToSection
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class consists of a link (probably
// inside a navigation) and a target, to which
// the window should scroll on click
//+++++++++++++++++++++++++++++++++++++++++++++++

// Constructor
DW.ScrollToSection = function(link, target) {
  this.link = link;
  this.target = typeof target !== 'undefined' ? target : document.querySelector(this.link.href.substr(this.link.href.indexOf('#')));
  this.link.addEventListener('click', this.scrollToTarget.bind(this));
};

// Methods
DW.ScrollToSection.prototype = {
  scrollToTarget : function(ev) {
    ev.preventDefault();
    var distance = this.target.offsetTop - window.pageYOffset;
    distance = distance < 0 ? distance * -1 : distance; // make sure it's a positive value
    distance = Math.min(500, distance / 3); // make sure it's not longer than 500
    DW.scrollTo(this.target.offsetTop, null, distance);
    ev.target.blur();
  },
};
